import React, { useState, useEffect } from "react";
import { COLORS } from "../../Constants/AppColors.js";
import { useTranslation } from "react-i18next";
import "../../Translation/i18n";
import i18n from "i18next";
// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Aos from "aos";
import "aos/dist/aos.css";
import Modal from "react-bootstrap/Modal";
import APIs from "../../network/APIs.js";
import "./style.css";

function IssuePage() {
  const { t } = useTranslation();

  const [innerWidthState, setInnerWidthState] = useState(window.innerWidth);
  const [innerHeightState, setInnerHeightState] = useState(window.innerHeight);
  const [directionState, setDirectionState] = useState("ltr");
  const [show, setShow] = useState(false);

  const [requestResponseState, setRequestResponseState] = useState([]);
  const [selectedIndexState, setSelectedIndexState] = useState(-1);
  // var selectedIndex = -1;

  

  React.useEffect(() => {
    Aos.init();

    const getIssues = () => {
      console.log("getIssues() Started");
      if (requestResponseState.length === 0)
        APIs.instance.getIssues().then(([statusCode, data]) => {
          if (statusCode === 200) {
            setRequestResponseState(data.results);
          }
        });
    };
  
    getIssues();

    if (i18n.language.includes("en")) {
      setDirectionState("ltr");
    } else {
      setDirectionState("rtl");
    }

    function handleResize() {
      console.log("resized to: ", window.innerWidth, "x", window.innerHeight);
      setInnerWidthState(window.innerWidth);
      setInnerHeightState(window.innerHeight);
    }

    window.addEventListener("resize", handleResize);

    console.log("i18n.locale: " + i18n.language);
  }, []);

  const [hover, setHover] = useState(false);

  const handleMouseIn = () => {
    setHover(true);
  };

  const handleMouseOut = () => {
    setHover(false);
  };

  const listItems = requestResponseState.map((item, index) => (
    <div
      data-aos="fade-zoom-out"
      data-aos-offset="100"
      class="col-11 col-md-6 col-lg-4 mx-0 mb-4 scrollbar scrollbar-lady-lips force-overflow"
    >
      <div
        class="card p-0 overflow-hidden h-100 shadow "
        style={{ borderRadius: 20 }}
      >
        <img
          src={require("../../assets/bg_header_item.png")}
          class="card-img-top img-fluid mx-auto d-block"
          style={{ height: "100%" }}
          alt=""
        />
        <div class="card-body " style={{ backgroundColor: "#EAEEF6" }}>
          <label
            style={{
              color: "#0047BA",
              marginTop: -10,
              fontSize: 20,
              marginBottom: 5,
              textAlign: i18n.language.includes("en") ? "left" : "right",
              width: "100%",
              fontFamily: i18n.language.includes("en")
                ? "CI-Font-Subtitle"
                : "CI-Font-Subtitle-ar",
            }}
          >
            {/* {t("issue") + (index + 1)} */}
            {i18n.language.includes("en") ? item.name_en : item.name_ar}
          </label>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: i18n.language.includes("en") ? "left" : "right",
              marginTop: 10,
              width: "100%",
              marginBottom: 20,
            }}
          >
            <label
              style={{
                color: "#049FDB",
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontSize: 14,
                whiteSpace: "pre-wrap",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Subtitle"
                  : "CI-Font-Subtitle-ar",
              }}
            >
              {t("Total_Amount")}
              {":  "}
            </label>
            <label
              style={{
                color: "#898D90",
                fontSize: 13,
                textAlign: i18n.language.includes("en") ? "left" : "right",

                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              {i18n.language.includes("en")
                ? item.total_amount_en
                : item.total_amount_ar}
            </label>
          </div>

          {i18n.language.includes("en") ? (
            <button
              style={{
                borderColor: "#ffffff01",
                alignItems: "center",
                justifyContent: i18n.language.includes("en") ? "left" : "right",
              }}
              // onMouseOver={handleMouseIn}
              // onMouseOut={handleMouseOut}
              onClick={() => {
                setSelectedIndexState(index);
                console.log("Selected Index: " + selectedIndexState);
                setShow(true);
              }}
              class="shape"
            >
              <text
                style={{
                  position: "relative",
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Body-Text"
                    : "CI-Font-Body-Text-ar",
                  fontSize: 13,
                  marginLeft: i18n.language.includes("en") ? -30 : 0,
                  marginRight: i18n.language.includes("ar") ? -30 : 0,
                  top: "-2.5px",
                }}
              >
                {t("read_more")}
              </text>
              {/* <img
              src={
                i18n.language.includes("en")
                  ? require("../../assets/left_read_more_btn.svg").default
                  : require("../../assets/right_read_more_btn.svg").default
              }
              style={{
                position: "absolute",
                bottom: i18n.language.includes("en") ? 15 : 15,
                left: i18n.language.includes("en") ? 10 : null,
                right: i18n.language.includes("ar") ? 10 : null,
              }}
              width="100"
              height="25"
              alt=""
            /> */}
            </button>
          ) : (
            <button
              style={{
                borderColor: "#ffffff01",
                alignItems: "center",
                justifyContent: i18n.language.includes("en") ? "left" : "right",
              }}
              // onMouseOver={handleMouseIn}
              // onMouseOut={handleMouseOut}
              onClick={() => {
                setSelectedIndexState(index);
                console.log("Selected Index: " + selectedIndexState);
                setShow(true);
              }}
              class="shape_ar"
            >
              <text
                style={{
                  position: "relative",
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Body-Text"
                    : "CI-Font-Body-Text-ar",
                  fontSize: 13,
                  marginLeft: i18n.language.includes("en") ? -30 : 0,
                  marginRight: i18n.language.includes("ar") ? -30 : 0,
                  top: "-2.5px",
                }}
              >
                {t("read_more")}
              </text>
              {/* <img
              src={
                i18n.language.includes("en")
                  ? require("../../assets/left_read_more_btn.svg").default
                  : require("../../assets/right_read_more_btn.svg").default
              }
              style={{
                position: "absolute",
                bottom: i18n.language.includes("en") ? 15 : 15,
                left: i18n.language.includes("en") ? 10 : null,
                right: i18n.language.includes("ar") ? 10 : null,
              }}
              width="100"
              height="25"
              alt=""
            /> */}
            </button>
          )}
        </div>
      </div>
    </div>
  ));

  return (
    <div
      dir={directionState}
      style={{
        backgroundColor: "#F7F8F9",
        backgroundSize: "cover",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <label
          style={{
            color: COLORS.PageTitleFirstColor,
            marginTop: 20,
            marginBottom: -20,
            fontSize: 35,
            textAlign: i18n.language.includes("en") ? "left" : "right",
            fontFamily: i18n.language.includes("en")
              ? "CI-Font-Title"
              : "CI-Font-Title-ar",
          }}
        >
          {t("menu_title_issues")}{" "}
        </label>
        <section className="py-4 py-lg-5 container">
          <div className="row">{listItems}</div>
        </section>
      </div>
      {selectedIndexState >= 0 ? (
        <Modal
          show={show}
          onHide={() => setShow(false)}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          centered
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title
              style={{
                color: "#0047BA",
                width: "100%",
                textAlign: "center",
                marginLeft: 25,
                marginTop: 10,
                fontSize: 20,
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Subtitle"
                  : "CI-Font-Subtitle-ar",
              }}
              id="example-custom-modal-styling-title"
            >
              {/* {t("issue") + (selectedIndexState + 1)} */}
              {i18n.language.includes("en")
                ? requestResponseState[selectedIndexState].name_en
                : requestResponseState[selectedIndexState].name_ar}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <label
                style={{
                  color: "#049FDB",
                  marginTop: 10,
                  fontSize: 17,
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Subtitle"
                    : "CI-Font-Subtitle-ar",
                }}
              >
                {t("Total_Amount")}
              </label>
              <label
                style={{
                  color: "#898D90",
                  marginTop: -2,
                  fontSize: 14,
                  textAlign: "center",
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Body-Text"
                    : "CI-Font-Body-Text-ar",
                }}
              >
                {i18n.language.includes("en")
                  ? requestResponseState[selectedIndexState].total_amount_en
                  : requestResponseState[selectedIndexState].total_amount_ar}
              </label>
              <label
                style={{
                  color: "#049FDB",
                  marginTop: 10,
                  fontSize: 17,
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Subtitle"
                    : "CI-Font-Subtitle-ar",
                }}
              >
                {t("Issuance_Date")}
              </label>
              <label
                style={{
                  color: "#898D90",
                  marginTop: -2,
                  fontSize: 14,
                  textAlign: "center",
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Body-Text"
                    : "CI-Font-Body-Text-ar",
                }}
              >
                {i18n.language.includes("en")
                  ? requestResponseState[selectedIndexState].issuance_date_en
                  : requestResponseState[selectedIndexState].issuance_date_ar}
              </label>
              <label
                style={{
                  color: "#049FDB",
                  marginTop: 10,
                  fontSize: 17,
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Subtitle"
                    : "CI-Font-Subtitle-ar",
                }}
              >
                {t("Maturity_Date")}
              </label>
              <label
                style={{
                  color: "#898D90",
                  marginTop: -2,
                  fontSize: 14,
                  textAlign: "center",
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Body-Text"
                    : "CI-Font-Body-Text-ar",
                }}
              >
                {i18n.language.includes("en")
                  ? requestResponseState[selectedIndexState].maturity_date_en
                  : requestResponseState[selectedIndexState].maturity_date_ar}
              </label>
              <label
                style={{
                  color: "#049FDB",
                  marginTop: 10,
                  fontSize: 17,
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Subtitle"
                    : "CI-Font-Subtitle-ar",
                }}
              >
                {t("Interest_Rate")}
              </label>
              <label
                style={{
                  color: "#898D90",
                  marginTop: -2,
                  fontSize: 14,
                  textAlign: "center",
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Body-Text"
                    : "CI-Font-Body-Text-ar",
                }}
              >
                {i18n.language.includes("en")
                  ? requestResponseState[selectedIndexState].interest_rate_en
                  : requestResponseState[selectedIndexState].interest_rate_ar}
              </label>
              <label
                style={{
                  color: "#049FDB",
                  marginTop: 10,
                  fontSize: 17,
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Subtitle"
                    : "CI-Font-Subtitle-ar",
                }}
              >
                {t("Portfolio_Referrer")}
              </label>
              <label
                style={{
                  color: "#898D90",
                  marginTop: -2,
                  fontSize: 14,
                  textAlign: "center",
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Body-Text"
                    : "CI-Font-Body-Text-ar",
                }}
              >
                {i18n.language.includes("en")
                  ? requestResponseState[selectedIndexState]
                      .portfolio_referrer_en
                  : requestResponseState[selectedIndexState]
                      .portfolio_referrer_ar}
              </label>
              <label
                style={{
                  color: "#049FDB",
                  marginTop: 10,
                  fontSize: 17,
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Subtitle"
                    : "CI-Font-Subtitle-ar",
                }}
              >
                {t("Custodian")}
              </label>
              <label
                style={{
                  color: "#898D90",
                  marginTop: -2,
                  fontSize: 14,
                  textAlign: "center",
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Body-Text"
                    : "CI-Font-Body-Text-ar",
                }}
              >
                {i18n.language.includes("en")
                  ? requestResponseState[selectedIndexState].custodian_en
                  : requestResponseState[selectedIndexState].custodian_ar}
              </label>
              <label
                style={{
                  color: "#049FDB",
                  marginTop: 10,
                  fontSize: 17,
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Subtitle"
                    : "CI-Font-Subtitle-ar",
                }}
              >
                {t("Collector")}
              </label>
              <label
                style={{
                  color: "#898D90",
                  marginTop: -2,
                  fontSize: 14,
                  textAlign: "center",
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Body-Text"
                    : "CI-Font-Body-Text-ar",
                }}
              >
                {i18n.language.includes("en")
                  ? requestResponseState[selectedIndexState].collector_en
                  : requestResponseState[selectedIndexState].collector_ar}
              </label>
              <label
                style={{
                  color: "#049FDB",
                  marginTop: 10,
                  fontSize: 17,
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Subtitle"
                    : "CI-Font-Subtitle-ar",
                }}
              >
                {t("The_nominal_value_of_the_bonds_upon_issuance")}
              </label>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
    </div>
  );
}

export default IssuePage;
